// Real Rate Calculator API — /api/V1/Rate/* (public endpoints; CSRF-protected
// but no sign-in required). Signatures mirror rateMock.ts.

import { postJson } from './http';
import type { PolicyType, RateEstimate, RateEstimateParams, StateOption } from '@/types/api';

const API = '/api/V1';

export const rateRealApi = {
  async getRatePolicyTypes(): Promise<PolicyType[]> {
    const res = await postJson<{ err: string; data?: PolicyType[] }>(`${API}/Rate/PolicyTypes`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },
  async getRateStates(): Promise<StateOption[]> {
    const res = await postJson<{ err: string; data?: StateOption[] }>(`${API}/Rate/States`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },
  async getRateCounties(): Promise<string[]> {
    const res = await postJson<{ err: string; data?: string[] }>(`${API}/Rate/Counties`);
    return res.err === '1' && Array.isArray(res.data) ? res.data : [];
  },
  async estimateRate(params: RateEstimateParams): Promise<RateEstimate> {
    const res = await postJson<{ err: string; data?: RateEstimate }>(`${API}/Rate/Estimate`, { ...params });
    if (res.err !== '1' || !res.data) throw new Error('Estimate failed');
    return res.data;
  },
};
